<template>
    <div id="sign_in">
        <div>
            <el-card>
                <div v-show="signIn==1">
                    <el-table
                            :data="tableData"
                            border
                            style="width: 100%">
<!--                        <el-table-column-->
<!--                                prop="image"-->
<!--                                label="图片"-->
<!--                                width="160px"-->
<!--                                align="center">-->
<!--                            <template slot-scope="scope">-->
<!--                                <img :src="scope.row.image" width="100" alt="">-->
<!--                            </template>-->
<!--                        </el-table-column>-->
                        <el-table-column
                                prop="title"
                                label="名称">
                        </el-table-column>
                        <el-table-column
                                prop="coin"
                                :label="this.$store.state.name">
                        </el-table-column>
                        <el-table-column
                                prop="desc"
                                label="说明">
                        </el-table-column>
                        <el-table-column
                                label="操作">
                            <template slot-scope="scope">
                                <el-button type="warning" plain size="small" @click="edit(scope.row.id)">
                                    修改
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

            </el-card>
            <!--            新增或编辑-->
            <el-dialog :title="fromTitle" width="50%" :visible.sync="visible">
                <el-row :gutter="20">
                    <el-col :span="15">
                        <el-form ref="form" label-width="150px" size="small">
<!--                            <el-form-item label="图片">-->
<!--                                <el-upload-->
<!--                                        class="avatar-uploader"-->
<!--                                        action="upDataUrl"-->
<!--                                        :show-file-list="false"-->
<!--                                        :http-request="myUpload"-->
<!--                                        :before-upload="beforeAvatarUpload">-->
<!--                                    <img v-if="form.image" :src="form.image" class="avatar">-->
<!--                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--                                </el-upload>-->
<!--                            </el-form-item>-->
                            <el-form-item label="名称">
                                <el-input v-model="form.title"></el-input>
                            </el-form-item>
                            <el-form-item :label="this.$store.state.name">
                                <el-input v-model="form.coin"></el-input>
                            </el-form-item>
                            <el-form-item label="说明">
                                <el-input v-model="form.desc"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {uploadimg} from "../../utils/common";

    export default {
        name: "sign_in",
        data() {
            return {
                form: {
                    image: '',
                    title: '',
                    coin: '',
                    desc: ''
                },
                tableData: [],
                visible: false,
                fromTitle: '',
                key_id: '',
                signIn: '1',
                id: ''

            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                this.$axios.post('admin/sign_rule/index', {}).then((res) => {
                    let obj = res.data;
                    let arr = [];
                    for (let key  in obj) {
                        Object.assign(obj[key], {keyId: key});
                        arr.push(obj[key])
                    }
                    this.tableData = arr;
                });
            },
            dialogClose() {
                this.visible = false
            },
            edit(id) {
                this.fromTitle = '修改';
                this.id = id;
                this.$axios.get('admin/sign_rule/' + id, {}).then((res) => {
                    this.form = res.data;
                    this.visible = true;
                });
            },
            myUpload(content) {
                uploadimg(content).then(res => {
                    this.form.image = res;
                    this.$forceUpdate()
                })
            },
            beforeAvatarUpload(file) {
                var suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                let arr = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF']
                if (arr.indexOf(suffix) === -1) {
                    this.$message.error('上传图片格式有误');
                    return false
                }
            },
            dialogAffirm() {
                this.$axios.put('admin/sign_rule/' + this.id, this.form).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                    this.visible = false
                });
            },
        }
    }
</script>

<style scoped>

</style>